export const Assumptions = {
  BankAssumptions: {
    Data: {}
  }
}
